import {invokeApi} from "../bl_libs/invokeApi";
import {LOCAL_STORAGE_KEYS} from "../utils/constants";
import {use_e2ee} from "../utils/utils";

export const uploadMedia = (media, progressCb) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/admin/storage/put',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`,
            'content-type': 'multipart/form-data'
        },
        onUploadProgress: progressCb
    };
    requestObj['postData'] = media;

    return invokeApi(requestObj);
}

export const fetchInsiderDocumentBlob = (dq_insider_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : `/admin/dq_insider/user/document_file?dq_insider_id=${encodeURIComponent(dq_insider_id)}`,
        method : 'GET',
        headers : {
            'Authorization' : `Bearer ${token}`
        },
    };
    return invokeApi(requestObj);
};

export const approveInsiderUserByAdminService = (member_id, approval_code) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : `/dq_insider/auth/dqin/approve/${member_id}/${approval_code}`,
        method : 'GET',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    return invokeApi(requestObj);
}

export const rejectInsiderUserByAdminService = (member_id, rejection_code) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : `/dq_insider/auth/dqin/reject/${member_id}/${rejection_code}`,
        method : 'GET',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };
    return invokeApi(requestObj);
}

export const getApprovalTrackCodesService = (dq_insider_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/admin/dq_insider/get/approval_track/codes',
        method : 'POST',
        headers : {
            'Authorization' : `Bearer ${token}`
        }
    };

    requestObj['postData'] = {
        dq_insider_id
    }

    return invokeApi(requestObj);
}